/* Pasos del escáner */
export enum PasoEscaner {
  FUENTE = 'fuente',
  USAR_CAMARA = 'usar_camara',
  RECORTE = 'recorte',
  CONFIRMAR = 'confirmar',
  AGREGAR = 'agregar',
  PDF = 'pdf',
}

/* Contorno de un documento */
export type ContornoDocumento = {
  topLeftCorner: { x: number; y: number };
  topRightCorner: { x: number; y: number };
  bottomLeftCorner: { x: number; y: number };
  bottomRightCorner: { x: number; y: number };
};

/* Puntos de un contorno */
export type PuntosContorno = { x: number; y: number }[];

/* Imagen del Escáner */
export type ImagenEscaner = {
  original: string;
  recortada: string;
};
